import {TranslationKey} from 'common/i18n';

export enum ExpiresModeOptions {
  Never = `Never`,
  Specify = `Specify...`,
}

export enum ExpiresUnit {
  Hour = `Hours`,
  Day = `Days`,
  Month = `Months`,
  Year = `Years`,
}

export const ExpiresUnitI18nKey: Record<ExpiresUnit, TranslationKey> = {
  [ExpiresUnit.Hour]: `settings.org-settings.invite-users.hours`,
  [ExpiresUnit.Day]: `settings.org-settings.invite-users.days`,
  [ExpiresUnit.Month]: `settings.org-settings.invite-users.months`,
  [ExpiresUnit.Year]: `settings.org-settings.invite-users.years`,
};

export const ExpiresModeOptionsI18nKey: Record<ExpiresModeOptions, TranslationKey> = {
  [ExpiresModeOptions.Never]: `settings.org-settings.invite-users.never`,
  [ExpiresModeOptions.Specify]: `settings.org-settings.invite-users.specify`,
};
